<template>
  <div>
    <v-card
      elevation="5"
    >
      <v-toolbar
        color="primaryLight"
        dark
        dense
      >
        <v-toolbar-title>Perímetros</v-toolbar-title>

        <v-tooltip
          bottom
        >
          <template
            #activator="{ on, attrs }"
          >
            <v-btn
              fab
              small
              v-bind="attrs"
              color="secondary"
              right
              absolute
              :disabled="disabledByRol || (isSymbologyPanelLocked && !isSymbologyPerimeterOpen)"
              v-on="on"
              @click="openAddPerimeterDialog"
            >
              <v-icon
                color="primary"
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>Añadir perímetro</span>
        </v-tooltip>
      </v-toolbar>

      <v-list
        subheader
      >
        <template
          v-for="(perimetro, index) in perimetros"
        >
          <div>
            <v-list-item
              :class="{ 'row-hovered': hoveredPerimetroId === perimetro.ID_PERIMETRO }"
              @mouseenter="hoveredPerimetroId = perimetro.ID_PERIMETRO"
              @mouseleave="hoveredPerimetroId = null"
            >
              <v-list-item-content>
                <v-list-item-title>{{ perimetro.NOMBRE }}</v-list-item-title>
                <v-list-item-subtitle>{{ formatDate(perimetro.FECHA) }} - Área: {{ area[index] }}ha - Perímetro {{ perimetroLon[index] }}km</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action
                v-if="hoveredPerimetroId === perimetro.ID_PERIMETRO"
              >
                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      icon
                      v-bind="attrs"
                      :disabled="showDialog || disabledByRol || (isSymbologyPanelLocked && !isSymbologyPerimeterOpen)"
                      v-on="on"
                      @click="openEditPerimeterDialog(perimetro)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
              </v-list-item-action>
              <v-list-item-action
                v-if="hoveredPerimetroId === perimetro.ID_PERIMETRO || idPerimetroShowing.includes(perimetro.ID_PERIMETRO)"
              >
                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      icon
                      v-bind="attrs"
                      :disabled="showDialog"
                      v-on="on"
                      @click="idPerimetroShowing.includes(perimetro.ID_PERIMETRO) ? mostrarPerimetro('remove',perimetro) : mostrarPerimetro('add',perimetro)"
                    >
                      <v-icon>{{ idPerimetroShowing.includes(perimetro.ID_PERIMETRO) ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ idPerimetroShowing.includes(perimetro.ID_PERIMETRO) ? 'Ocultar' : 'Visualizar' }}</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index < perimetros?.length - 1"
              style="margin-right: 1rem; margin-left: 1rem;"
            />
          </div>
        </template>
        <p
          v-if="perimetros?.length <= 0"
          align="center"
          style="margin: 16px 10px 10px 10px; color: gray;"
        >
          No hay ningún perímetro
        </p>
      </v-list>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="perimetrosDescarga?.length === 0"
          @click="descargarKML"
        >
          <v-icon
            left
          >
            mdi-download
          </v-icon> Descargar KML
        </v-btn>
        <v-btn
          :disabled="perimetrosDescarga?.length === 0"
          @click="descargarSHP"
        >
          <v-icon
            left
          >
            mdi-download
          </v-icon> Descargar SHP
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :top="true"
      :timeout="3000"
    >
      <v-icon>mdi-alert</v-icon>
      {{ snackbarText }}
    </v-snackbar>

    <!--Desde aquí llamamos a todas las funciones necesarias-->
    <vx-dialog-menu-perimetro
      :show="showDialog"
      :id-incendio="idIncendio"
      :perimetro-selected="perimetroSelected"
      :is-edit="isEdit"
      @close="showDialog = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as ArcGIS from '../../../helpers/ArcGIS'
import DialogMenuPerimetro from './DialogMenuPerimetro'

export default {

  components: {
    'vx-dialog-menu-perimetro': DialogMenuPerimetro
  },
  props: { // con esto conseguimos la id del incendio donde estamos
    idIncendio: String
  },

  data() {
    return {
      showDialog: false,
      isEdit: false,
      idPerimetroShowing: [],
      perimetroSelected: null,
      perimetrosDescarga: [],

      area: [],
      perimetroLon: [],

      showSnackbar: false,
      snackbarColor: 'error',
      snackbarText: '',

      hoveredPerimetroId: null,
      perimetrosActivos: []
    }
  },

  computed: {

    ...mapGetters({
      isSymbologyPanelLocked: 'map/isSymbologyPanelLocked',
      isSymbologyPerimeterOpen: 'map/isSymbologyPerimeterOpen'
    }),

    incendio() {
      return this.$store.getters['incendio/getIncendioByID'](this.idIncendio)
    },
    perimetros() {
      let perimetros = []

      if (this.incendio) {
        perimetros = this.incendio.PERIMETRO
      }
      return perimetros
    },
    disabledByRol() {
      // Deshabilita funciones dependiendo del rol
      return !this.$store.getters['usuario/isCurrentUsuarioAdmin']
    }
  },
  watch: {

    showPerimetros() {
      if (this.showPerimetros) {
        this.idPerimetroShowing = []
      }
    },

    async perimetros() {
      if (this.idPerimetroShowing && this.perimetros) {
        const perimetro = this.perimetros.find(x => x.ID_PERIMETRO === this.idPerimetroShowing)
        if (perimetro) {
          const graficosPerimetro = this.perimetros.find(x => x.ID_PERIMETRO === this.idPerimetroShowing).GRAFICOS_PERIMETRO

          ArcGIS.drawGraphicsPerimetro(graficosPerimetro)
          ArcGIS.measurePerimetros(graficosPerimetro)
        }
      }

      try {
        if (this.perimetros) {
          this.area = []
          this.perimetroLon = []

          const promesas = this.perimetros.map(async perimetro => {
            const graficosPerimetro = this.perimetros.find(x => x.ID_PERIMETRO === perimetro.ID_PERIMETRO).GRAFICOS_PERIMETRO
            const aux = await ArcGIS.measurePerimetros(graficosPerimetro)

            if (aux.area === null || aux.perimetro === null) {
              throw new Error()
            }

            return aux
          })

          const resultados = await Promise.all(promesas)

          this.area = resultados.map(r => r.area)
          this.perimetroLon = resultados.map(r => r.perimetro)
        }
      } catch {
        this.snackbarError('Error al cargar las medidas de los perímetros')
      }
    }

  },

  methods: {
    formatDate(date) {
      return this.$date.formatDate(date, 'LLL')
    },

    descargarKML() {
      ArcGIS.exportPerimetros(this.perimetrosDescarga, 'KML')
    },

    descargarSHP() {
      ArcGIS.exportPerimetros(this.perimetrosDescarga, 'SHP')
    },

    openAddPerimeterDialog() {
      this.mostrarPerimetro(null)
      this.isEdit = false
      this.showDialog = true
    },

    openEditPerimeterDialog(perimetro) {
      this.mostrarPerimetro(null)
      this.perimetroSelected = perimetro
      this.isEdit = true
      this.showDialog = true
    },

    mostrarPerimetro(action, perimetro) {
      this.perimetroSelected = perimetro

      if (action === 'add' && perimetro) {
        this.perimetrosDescarga.push(perimetro)
        this.idPerimetroShowing.push(perimetro.ID_PERIMETRO)
        ArcGIS.drawGraphicsPerimetro(perimetro.GRAFICOS_PERIMETRO)
      } else if (action === 'remove' && perimetro) {
        this.idPerimetroShowing = this.idPerimetroShowing.filter(
          id => id !== perimetro.ID_PERIMETRO
        )

        this.perimetrosDescarga = this.perimetrosDescarga.filter(
          p => p.ID_PERIMETRO !== perimetro.ID_PERIMETRO
        )
        ArcGIS.removeGraphicsPerimetro(perimetro.GRAFICOS_PERIMETRO)
      }
    },

    snackbarError(msg) {
      this.showSnackbar = true
      this.snackbarText = msg
    }
  }
}
</script>

<style scoped>
.row-hovered {
  background-color: rgb(0,0,0,0.05)
}
</style>
